import { LoadableFactory } from '®shared/data';

import {
  LibraryAvailabilityActionTypes,
  LibraryAvailabilityActions,
} from './library-availability.actions';
import { LibraryAvailabilityState } from './library-availability.state';

export function libraryAvailabilityReducer(
  state: LibraryAvailabilityState,
  action: LibraryAvailabilityActions,
): LibraryAvailabilityState {
  switch (action.type) {
    case LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_REQUESTED: {
      const { resourceId } = action.payload;
      return {
        ...state,
        [resourceId]: LoadableFactory.loading(),
      };
    }
    case LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_LOADED: {
      const { resourceId, libraryAvailability } = action.payload;
      return {
        ...state,
        [resourceId]: LoadableFactory.loaded(libraryAvailability),
      };
    }
    case LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_LOADING_FAILED: {
      const { resourceId, error } = action.payload;
      return {
        ...state,
        [resourceId]: LoadableFactory.errored(error),
      };
    }
    default: {
      return state;
    }
  }
}
